import { defaultTemplate } from "core/hoc";
import PropTypes from "prop-types";
import React from "react";
import { Content } from "core/layouts";
import { DatePicker, BasicCheckbox, BaasicButton } from "core/components";
import { Tooltip as ReactTooltip } from "react-tooltip";

function DispensingOrderWoundItemTemplate({
    wound,
    dispensingOrderReviewViewStore,
}) {
    const woundInfo = wound
        ? wound.woundDressings.map((item) => (
              <tr key={item.id}>
                  <td>
                      <div className="table--review__content">
                          <span className="table--review__content__name">
                              {item.product.description}
                          </span>
                          <div
                              data-tooltip-content={
                                  !wound.isMissingDispensingOrder
                                      ? "Mark as not included in the order"
                                      : ""
                              }
                              data-tooltip-id={!wound.isMissingDispensingOrder ? "btn-check-review" : ""}
                          >
                              <BasicCheckbox
                                  id={item.id + "isMissingDressing"}
                                  checked={item.isDressingNotIncludedInOrder}
                                  onChange={() =>
                                      (item.isDressingNotIncludedInOrder =
                                          !item.isDressingNotIncludedInOrder)
                                  }
                                  className="input--check input--check--review table--review__content__checkbox"
                                  disabled={wound.isMissingDispensingOrder}
                              />
                          </div>
                      </div>
                  </td>
                  <td>
                      <div className="table--review__content">
                          <span className="table--review__content__name">
                              {item.applicationType.name}
                          </span>
                          <div
                              data-tooltip-content={
                                  !wound.isMissingDispensingOrder
                                      ? "Mark as not included in the order"
                                      : ""
                              }
                              data-tooltip-id={!wound.isMissingDispensingOrder ? "btn-check-review" : ""}
                          >
                              <BasicCheckbox
                                  id={item.id + "isMissingFoc"}
                                  checked={item.isFocNotIncludedInOrder}
                                  onChange={() =>
                                      (item.isFocNotIncludedInOrder =
                                          !item.isFocNotIncludedInOrder)
                                  }
                                  className="input--check input--check--review table--review__content__checkbox"
                                  disabled={wound.isMissingDispensingOrder}
                              />
                          </div>
                      </div>
                  </td>
                  <td>
                      <div className="table--review__content">
                          <span className="table--review__content__name">
                              {item.frequencyOfCare.name}
                          </span>
                          <div
                              data-tooltip-content={
                                  !wound.isMissingDispensingOrder
                                      ? "Mark as not included in the order"
                                      : ""
                              }
                              data-tooltip-id={!wound.isMissingDispensingOrder ? "btn-check-review" : ""}
                          >
                              <BasicCheckbox
                                  id={item.id + "isMissingApplicationType"}
                                  checked={
                                      item.isApplicationTypeNotIncludedInOrder
                                  }
                                  onChange={() =>
                                      (item.isApplicationTypeNotIncludedInOrder =
                                          !item.isApplicationTypeNotIncludedInOrder)
                                  }
                                  className="input--check input--check--review table--review__content__checkbox"
                                  disabled={wound.isMissingDispensingOrder}
                              />
                          </div>
                      </div>
                  </td>
              </tr>
          ))
        : [];
    return (
        <Content>
            <div className="card--facility__secondary">
                <div className="card--facility__header">
                    <div className="card--facility__header__wrapper">
                        <div className="card--facility__header__title">
                            {wound.location}
                        </div>
                    </div>
                    {!wound.hasCompletedWoundDispensingOrder && (
                        <div data-tooltip-content="Check as reviewed" data-tooltip-id="btn-review">
                            <BaasicButton
                                onlyIcon
                                className="btn btn--icon--sml-med btn--primary"
                                icon="u-icon u-icon--sml u-icon--task-square"
                                onClick={() => {
                                    dispensingOrderReviewViewStore.submitWoundDispensingOrder(
                                        wound,
                                        true
                                    );
                                }}
                            />
                        </div>
                    )}

                    {wound.hasCompletedWoundDispensingOrder && (
                        <BaasicButton
                            label="Reviewed"
                            className="btn btn--base btn--white type--color--text"
                            icon="u-icon u-icon--sml u-icon--approved"
                            onClick={() => {
                                dispensingOrderReviewViewStore.submitWoundDispensingOrder(
                                    wound,
                                    false
                                );
                            }}
                        />
                    )}
                </div>
                <div className="card--facility__content card--facility__content--col">
                    <div className="card--facility__date">
                        <div className="card--facility__date__group">
                            <p>Initial Assessment Date</p>
                            <DatePicker
                                value={wound.initialAssessmentDate}
                                onChange={(newDate) =>
                                    (wound.initialAssessmentDate = newDate)
                                }
                                disabled={
                                    wound.hasCompletedWoundDispensingOrder
                                }
                            />
                        </div>
                        <div className="card--facility__date__group">
                            <p>Dispensing Order Date</p>
                            <DatePicker
                                value={wound.dispensingOrderDate}
                                onChange={(newDate) =>
                                    (wound.dispensingOrderDate = newDate)
                                }
                                disabled={
                                    wound.isMissingDispensingOrder ||
                                    wound.hasCompletedWoundDispensingOrder
                                }
                            />
                        </div>
                        <BasicCheckbox
                            disabled={wound.hasCompletedWoundDispensingOrder}
                            id={wound.id + "isMissingDispensingOrder"}
                            checked={wound.isMissingDispensingOrder}
                            onChange={() =>
                                (wound.isMissingDispensingOrder =
                                    !wound.isMissingDispensingOrder)
                            }
                            label="Dispensing order is missing"
                            className="input--check input--check--review"
                        />
                    </div>
                    <div className="table--review__wrapper">
                        <table
                            className="table--review"
                            disabled={
                                wound.isMissingDispensingOrder ||
                                wound.hasCompletedWoundDispensingOrder
                            }
                        >
                            <thead>
                                <tr>
                                    <th>Dressing</th>
                                    <th>FOC</th>
                                    <th>Application</th>
                                </tr>
                            </thead>
                            <tbody>{woundInfo}</tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ReactTooltip positionStrategy="fixed" id="btn-check-review" place="top" />
            <ReactTooltip positionStrategy="fixed" id="btn-review" place="top" />
        </Content>
    );
}

DispensingOrderWoundItemTemplate.propTypes = {
    dispensingOrderReviewViewStore: PropTypes.object,
    wound: PropTypes.object
};

export default defaultTemplate(DispensingOrderWoundItemTemplate);
